const defaultFields = [
  {
    key: 'id',
    field: 'id',
    title: 'id',
    label: 'id',
    cell: 'navigation',
    sortable: true,
	 },
  {
    key: 'questionText',
    field: 'questionText',
    title: 'Question Text',
    label: 'Question Text',
    sortable: true,
	 },
  {
    key: 'questionType',
    field: 'questionType',
    title: 'Question Type',
    label: 'Question Type',
    sortable: true,
	 },
  {
    key: 'dateCreated',
    field: 'dateCreated',
    title: 'Date Created',
    label: 'Date Created',
    cell: 'formatDate',
    sortable: true,
	 },
  {
    key: 'dateModified',
    field: 'dateModified',
    title: 'Date Modified',
    label: 'Date Modified',
    cell: 'formatDate',
    sortable: true,
	 },
  {
    key: 'createdByUserId',
    field: 'createdByUserId',
    title: 'Created By User Id',
    label: 'createdByUserId',
    sortable: true,
	 },
  {
    key: 'createdByUserFullName',
    field: 'createdByUserFullName',
    title: 'Created By User Full Name',
    label: 'Created By User Full Name',
    sortable: true,
	 },
  {
    key: 'modifiedByUserId',
    field: 'modifiedByUserId',
    title: 'modifiedByUserId',
    label: 'modifiedByUserId',
    sortable: true,
	 },
  {
    key: 'modifiedByUserFullName',
    field: 'modifiedByUserFullName',
    title: 'Modified By User Id',
    label: 'Modified By User Full Name',
    sortable: true,
	 },
  {
    key: 'active',
    field: 'active',
    title: 'Active',
    label: 'Active',
    sortable: true,
	 },
  {
    key: '',
    field: '',
    title: '',
    label: '',
    headerCell: 'commandsHeader',
    sortable: false,
    width: 30
	 },

]

export default defaultFields;
